/*
 * Copyright (C) 2018 Bruno López Trigo
 * 
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import { API_ROOT } from "../../config";

export async function startSession() {
  const response = await fetch(API_ROOT + "/session/start")
    .then(res => {
      return { error: false, data: res.headers.get("Authorization") };
    })
    .catch(error => {
      return { error: true, data: "Service unavailable, please try later" };
    });

  return response;
}

export async function closeSession(token) {
  const response = await fetch(API_ROOT + "/session/close", {
    method: "DELETE",
    headers: {
      Authorization: token,
      "Content-Type": "application/json"
    }
  })
    .then(res => {
      if (res.status === 200) {
        return res.json().then(data => {
          return { error: false, status: res.status, data: data.message };
        });
      } else {
        return res.json().then(data => {
          return { error: true, status: res.status, data: data.message };
        });
      }
    })
    .catch(error => {
      return {
        error: true,
        status: 401,
        data: "Unauthorized, please restart session"
      };
    });

  return response;
}

export async function getDataset(name, token) {
  const response = await fetch(API_ROOT + "/dataset/" + name, {
    headers: {
      Authorization: token,
      "Content-Type": "application/json"
    }
  })
    .then(res => {
      if (res.status === 200) {
        return res.json().then(data => {
          return { error: false, status: res.status, data: data };
        });
      } else {
        return res.json().then(data => {
          return { error: true, status: res.status, data: data.message };
        });
      }
    })
    .catch(error => {
      return {
        error: true,
        status: 401,
        data: "Unauthorized, please restart session"
      };
    });

  return response;
}

export async function getTest(name, token) {
  const response = await fetch(API_ROOT + "/dataset/" + name + "/test", {
    headers: {
      Authorization: token,
      "Content-Type": "application/json"
    }
  })
    .then(res => {
      if (res.status === 200) {
        return res.json().then(data => {
          return { error: false, status: res.status, data: data };
        });
      } else {
        return res.json().then(data => {
          return { error: true, status: res.status, data: data.message };
        });
      }
    })
    .catch(error => {
      return {
        error: true,
        status: 401,
        data: "Unauthorized, please restart session"
      };
    });

  return response;
}

export async function deleteDataset(name, token) {
  const response = await fetch(API_ROOT + "/dataset/" + name, {
    method: "DELETE",
    headers: {
      Authorization: token,
      "Content-Type": "application/json"
    }
  })
    .then(res => {
      if (res.status === 200) {
        return res.json().then(data => {
          return { error: false, status: res.status, data: data };
        });
      } else {
        return res.json().then(data => {
          return { error: true, status: res.status, data: data.message };
        });
      }
    })
    .catch(error => {
      return {
        error: true,
        status: 401,
        data: "Unauthorized, please restart session"
      };
    });

  return response;
}

export async function getDatasets(token) {
  const response = await fetch(API_ROOT + "/dataset", {
    headers: {
      Authorization: token,
      "Content-Type": "application/json"
    }
  })
    .then(res => {
      if (res.status === 200) {
        return res.json().then(data => {
          return { error: false, status: res.status, data: data };
        });
      } else {
        return res.json().then(data => {
          return { error: true, status: res.status, data: data.message };
        });
      }
    })
    .catch(error => {
      return {
        error: true,
        status: 401,
        data: "Unauthorized, please restart session"
      };
    });

  return response;
}

export async function getConfig(dataset, lang, token) {
    console.log(dataset)
  const response = await fetch(
    API_ROOT + "/classifier/config/" + dataset + "?lang=" + lang,
    {
      headers: {
        Authorization: token,
        "Content-Type": "application/json"
      }
    }
  )
    .then(res => {
      if (res.status === 200) {
        return res.json().then(data => {
          return { error: false, status: res.status, data: data };
        });
      } else {
        return res.json().then(data => {
          return { error: true, status: res.status, data: data.message };
        });
      }
    })
    .catch(error => {
      return {
        error: true,
        status: 401,
        data: "Unauthorized, please restart session"
      };
    });

  return response;
}

export async function getTree(dataset, algorithm, lang, token) {
  const response = await fetch(
    API_ROOT +
      "/classifier/tree/" +
      dataset +
      "/" +
      algorithm +
      "?lang=" +
      lang,
    {
      headers: {
        Authorization: token,
        "Content-Type": "application/json"
      }
    }
  )
    .then(res => {
      if (res.status === 200) {
        return res.json().then(data => {
          return { error: false, status: res.status, data: data };
        });
      } else {
        return res.json().then(data => {
          return { error: true, status: res.status, data: data.message };
        });
      }
    })
    .catch(error => {
      return {
        error: true,
        status: 401,
        data: "Unauthorized, please restart session"
      };
    });

  return response;
}
export async function getSomeTree(dataset, lang, token) {
    const response = await fetch(
        API_ROOT +
        "/classifier/tree/some/" +
        dataset +
        "?lang=" +
        lang,
        {
            headers: {
                Authorization: token,
                "Content-Type": "application/json"
            }
        }
    )
        .then(res => {
            if (res.status === 200) {
                return res.json().then(data => {
                    return { error: false, status: res.status, data: data };
                });
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: "Unauthorized, please restart session"
            };
        });

    return response;
}

export async function getRules(dataset, algorithm, lang, token) {
  const response = await fetch(
    API_ROOT +
      "/classifier/fuzzy/" +
      dataset +
      "/" +
      algorithm +
      "?lang=" +
      lang,
    {
      headers: {
        Authorization: token,
        "Content-Type": "application/json"
      }
    }
  )
    .then(res => {
      if (res.status === 200) {
        return res.json().then(data => {
          return { error: false, status: res.status, data: data };
        });
      } else {
        return res.json().then(data => {
          return { error: true, status: res.status, data: data.message };
        });
      }
    })
    .catch(error => {
      return {
        error: true,
        status: 401,
        data: "Unauthorized, please restart session"
      };
    });

  return response;
}

export async function getMatrix(dataset, algorithm, token, type) {
  const response = await fetch(
    API_ROOT +
      "/classifier/matrix/" +
      dataset +
      "/" +
      algorithm +
      "?type=" +
      type,
    {
      headers: {
        Authorization: token,
        "Content-Type": "application/json"
      }
    }
  )
    .then(res => {
      if (res.status === 200) {
        return res.json().then(data => {
          return { error: false, status: res.status, data: data };
        });
      } else {
        return res.json().then(data => {
          return { error: true, status: res.status, data: data.message };
        });
      }
    })
    .catch(error => {
      return {
        error: true,
        status: 401,
        data: "Unauthorized, please restart session"
      };
    });

  return response;
}

export async function getClassifications(
  dataset,
  algorithm,
  lang,
  instance,
  percentage,
  token
) {
  const response = await fetch(
    API_ROOT +
      "/classifier/" +
      dataset +
      "/" +
      algorithm +
      "/alternatives?lang=" +
      lang +
      "&percentage=" +
      percentage,
    {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(instance)
    }
  )
    .then(res => {
      if (res.status === 201) {
        return res.json().then(data => {
          return { error: false, status: res.status, data: data };
        });
      } else {
        return res.json().then(data => {
          return { error: true, status: res.status, data: data.message };
        });
      }
    })
    .catch(error => {
      return {
        error: true,
        status: 401,
        data: "Unauthorized, please restart session"
      };
    });

  return response;
}
export async function getSomeClassifications(
    dataset,
    lang,
    percentage,
    instance,
    token
) {
    const response = await fetch(
        API_ROOT +
        "/classifier/" +
        dataset +
        "/some/alternatives?lang=" +
        lang +
        "&percentage=" +
        percentage,
        {
            method: "POST",
            headers: {
                Authorization: token,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(instance)
        }
    )
        .then(res => {
            if (res.status === 201) {
                return res.json().then(data => {
                    return { error: false, status: res.status, data: data };
                });
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: "Unauthorized, please restart session"
            };
        });

    return response;
}

export async function getClassificationsRandomForest(
    dataset,
    algorithm,
    lang,
    instance,
    numInstance,
    token
) {
    const response = await fetch(
        API_ROOT +
        "/classifier/randomForest/" +
        dataset +
        "/" +
        algorithm +"?lang=" +
            lang +"&instance=" + numInstance,
        {
            method: "POST",
            headers: {
                Authorization: token,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(instance)
        }
    )
        .then(res => {
            if (res.status === 201) {
                return res.json().then(data => {
                    return { error: false, status: res.status, data: data.message };
                });
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: "Unauthorized, please restart session"
            };
        });

    return response;
}

export async function getClassificationsFuzzy(
  dataset,
  algorithm,
  lang,
  instance,
  percentage,
  token,
) {
  const response = await fetch(
    API_ROOT +
      "/classifier/" +
      dataset +
      "/" +
      algorithm +
      "/fuzzy?lang=" +
      lang +
      "&percentage=" +
      percentage,
    {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(instance)
    }
  )
    .then(res => {
      if (res.status === 201) {
        return res.json().then(data => {
          return { error: false, status: res.status, data: data };
        });
      } else {
        return res.json().then(data => {
          return { error: true, status: res.status, data: data.message };
        });
      }
    })
    .catch(error => {
      return {
        error: true,
        status: 401,
        data: "Unauthorized, please restart session"
      };
    });

  return response;
}
export async function getClassificationsTreeFuzzy(
    dataset,
    algorithm,
    lang,
    instance,
    percentage,
    token
) {
  const response = await fetch(
      API_ROOT +
      "/classifier/" +
      dataset +
      "/" +
      algorithm +
      "/treeFuzzy?lang=" +
      lang +
      "&percentage=" +
      percentage,
      {
        method: "POST",
        headers: {
          Authorization: token,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(instance)
      }
  )
      .then(res => {
        if (res.status === 201) {
          return res.json().then(data => {
            return { error: false, status: res.status, data: data };
          });
        } else {
          return res.json().then(data => {
            return { error: true, status: res.status, data: data.message };
          });
        }
      })
      .catch(error => {
        return {
          error: true,
          status: 401,
          data: "Unauthorized, please restart session"
        };
      });

  return response;
}
export async function getClassificationsHtRules(
    dataset,
    algorithm,
    lang,
    instance,
    percentage,
    token
) {
    const response = await fetch(
        API_ROOT +
        "/classifier/" +
        dataset +
        "/" +
        algorithm +
        "/htRules?lang=" +
        lang +
        "&percentage=" +
        percentage,
        {
            method: "POST",
            headers: {
                Authorization: token,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(instance)
        }
    )
        .then(res => {
            if (res.status === 201) {
                return res.json().then(data => {
                    return { error: false, status: res.status, data: data };
                });
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: "Unauthorized, please restart session"
            };
        });

    return response;
}
export async function getGlobalExplanation(dataset, algorithm, lang, token) {
  const response = await fetch(
    API_ROOT + "/explainer/" + dataset + "/" + algorithm + "?lang=" + lang,
    {
      headers: {
        Authorization: token,
        "Content-Type": "application/json"
      }
    }
  )
    .then(res => {
      if (res.status === 200) {
        return res.json().then(data => {
          return { error: false, status: res.status, data: data };
        });
      } else {
        return res.json().then(data => {
          return { error: true, status: res.status, data: data.message };
        });
      }
    })
    .catch(error => {
      return {
        error: true,
        status: 401,
        data: "Unauthorized, please restart session"
      };
    });

  return response;
}

export async function getConfusionBetween(
  dataset,
  algorithm,
  consequents,
  lang,
  token,
  type
) {
  const explanation = await fetch(
    API_ROOT +
      "/explainer/" +
      dataset +
      "/" +
      algorithm +
      "/confusion/?lang=" +
      lang +
      "&type=" +
      type,
    {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(consequents)
    }
  )
    .then(res => {
      if (res.status === 201) {
        return res.json().then(data => {
          return { error: false, status: res.status, data: data };
        });
      } else {
        return res.json().then(data => {
          return { error: true, status: res.status, data: data.message };
        });
      }
    })
    .catch(error => {
      return {
        error: true,
        status: 401,
        data: "Unauthorized, please restart session"
      };
    });

  return explanation;
}

export async function getLocalExplanation(
  dataset,
  algorithm,
  classifications,
  lang,
  token
) {
  const response = await fetch(
    API_ROOT + "/explainer/" + dataset + "/" + algorithm + "?lang=" + lang,
    {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(classifications)
    }
  )
    .then(res => {
      if (res.status === 201) {
        return res.json().then(data => {
          return { error: false, status: res.status, data: data };
        });
      } else {
        return res.json().then(data => {
          return { error: true, status: res.status, data: data.message };
        });
      }
    })
    .catch(error => {
      return {
        error: true,
        status: 401,
        data: "Unauthorized, please restart session"
      };
    });

  return response;
}

export async function getSomeLocalExplanation(
    dataset,
    classificationsJ48,
    classificationsREPTree,
    classificationsRandomTree,
    classificationsFURIA,
    classificationsHoeffdingTreeFuzzy,
    lang,
    token
) {
    const response = await fetch(
        API_ROOT + "/explainer/" + dataset + "/some?lang=" + lang,
        {
            method: "POST",
            headers: {
                Authorization: token,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(
                {classificationsJ48:classificationsJ48,
                classificationsREPTree:classificationsREPTree,
                classificationsRandomTree:classificationsRandomTree,
                classificationsFURIA:classificationsFURIA,
                rulesHoeffdingTreeFuzzy:classificationsHoeffdingTreeFuzzy})
        }
    )
        .then(res => {
            if (res.status === 201) {
                return res.json().then(data => {
                    return { error: false, status: res.status, data: data };
                });
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: "Unauthorized, please restart session"
            };
        });

    return response;
}

export async function getFuzzyLocalExplanation(
  dataset,
  algorithm,
  rules,
  lang,
  token
) {
  const response = await fetch(
    API_ROOT +
      "/explainer/" +
      dataset +
      "/" +
      algorithm +
      "/fuzzy?lang=" +
      lang,
    {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(rules)
    }
  )
    .then(res => {
      if (res.status === 201) {
        return res.json().then(data => {
          return { error: false, status: res.status, data: data };
        });
      } else {
        return res.json().then(data => {
          return { error: true, status: res.status, data: data.message };
        });
      }
    })
    .catch(error => {
      return {
        error: true,
        status: 401,
        data: "Unauthorized, please restart session"
      };
    });

  return response;
}

export async function uploadDataset(name, file, token) {
  const data = new FormData();
  data.append("file", file);
  const response = await fetch(API_ROOT + "/dataset/" + name, {
    method: "POST",
    headers: {
      Authorization: token
    },
    body: data
  })
    .then(res => {
      if (res.status === 201) {
        return res.json().then(data => {
          return { error: false, status: res.status, data: data };
        });
      } else {
        return res.json().then(data => {
          return { error: true, status: res.status, data: data.message };
        });
      }
    })
    .catch(error => {
      return {
        error: true,
        status: 401,
        data: "Unauthorized, please restart session"
      };
    });

  return response;
}

export async function uploadDatasetScratch(name, file, token) {
    const data = new FormData();
    data.append("file", file);
    const response = await fetch(API_ROOT + "/dataset/scratch/" + name, {
        method: "POST",
        headers: {
            Authorization: token
        },
        body: data
    })
        .then(res => {
            if (res.status === 201) {
                return res.json().then(data => {
                    return { error: false, status: res.status, data: data };
                });
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: "Unauthorized, please restart session"
            };
        });

    return response;
}


export async function buildClassifier(name, params, classifier, token) {
  const response = await fetch(
    API_ROOT + "/builder/" + name + "/" + classifier,
    {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(params)
    }
  )
    .then(res => {
      if (res.status === 201) {
        return res.json().then(data => {
          return { error: false, status: res.status, data: data };
        });
      } else {
        return res.json().then(data => {
          return { error: true, status: res.status, data: data.message };
        });
      }
    })
    .catch(error => {
      return {
        error: true,
        status: 401,
        data: "Unauthorized, please restart session"
      };
    });

  return response;
}
export async function buildSomeClassifier(name, booleanJ48,booleanRandomTree,booleanREPTree,booleanFURIA,
                                          booleanHoeffdingTreeFuzzy, booleanRandomForest,paramsJ48,paramsRT,
                                          paramsRep, paramsFURIA, paramsHtFuzzy, paramsRF, token) {
    const response = await fetch(
        API_ROOT + "/builder/some/" + name  ,
        {
            method: "POST",
            headers: {
                Authorization: token,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(
                {
                    j48:booleanJ48,
                    randomTree:booleanRandomTree,
                    repTree:booleanREPTree,
                    furia: booleanFURIA,
                    hoeffdingTreeFuzzy:booleanHoeffdingTreeFuzzy,
                    randomForest:booleanRandomForest,
                    buildParamsJ48:paramsJ48,
                    buildParamsRT:paramsRT,
                    buildParamsREP:paramsRep,
                    buildParamsFURIA:paramsFURIA,
                    buildParamsHTFuzzy:paramsHtFuzzy,
                    buildParamsRF:paramsRF
                })
        }
    )
        .then(res => {
            if (res.status === 201) {
                return res.json().then(data => {
                    return { error: false, status: res.status, data: data };
                });
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: "Unauthorized, please restart session"
            };
        });

    return response;
}

export async function getSomeExplanations(dataset, lang, token) {
    const response = await fetch(
        API_ROOT + "/explainer/some/" + dataset  + "?lang=" + lang,
        {
            headers: {
                Authorization: token,
                "Content-Type": "application/json"
            }
        }
    )
        .then(res => {
            if (res.status === 200) {
                return res.json().then(data => {
                    return { error: false, status: res.status, data: data };
                });
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: "Unauthorized, please restart session"
            };
        });

    return response;
}
export async function buildSomeModels(name,booleanJ48,booleanRandomTree,booleanREPTree,booleanFURIA,
                                      booleanHoeffdingTreeFuzzy, booleanRandomForest,paramsJ48,paramsRT,
                                      paramsRep, paramsFURIA, paramsHtFuzzy, paramsRF,token) {
    const response = await fetch(
        API_ROOT + "/classifier/some/" + name  ,
        {
            method: "POST",
            headers: {
                Authorization: token,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(
                {
                    j48:booleanJ48,
                    randomTree:booleanRandomTree,
                    repTree:booleanREPTree,
                    furia: booleanFURIA,
                    hoeffdingTreeFuzzy:booleanHoeffdingTreeFuzzy,
                    randomForest:booleanRandomForest,
                    buildParamsJ48:paramsJ48,
                    buildParamsRT:paramsRT,
                    buildParamsREP:paramsRep,
                    buildParamsFURIA:paramsFURIA,
                    buildParamsHTFuzzy:paramsHtFuzzy,
                    buildParamsRF:paramsRF
                })
        }
    )
        .then(res => {
            if (res.status === 201) {
                return res.json().then(data => {
                    return { error: false, status: res.status, data: data };
                });
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: "Unauthorized, please restart session"
            };
        });

    return response;
}

export async function getInformationGraphComparation(name,booleanJ48,booleanRandomTree,booleanREPTree,booleanFURIA,
                                      booleanHoeffdingTreeFuzzy, booleanRandomForest,token) {
    const response = await fetch(
        API_ROOT + "/classifier/graphComparative/" + name  ,
        {
            method: "POST",
            headers: {
                Authorization: token,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(
                {
                    j48:booleanJ48,
                    randomTree:booleanRandomTree,
                    repTree:booleanREPTree,
                    furia: booleanFURIA,
                    hoeffdingTreeFuzzy:booleanHoeffdingTreeFuzzy,
                    randomForest:booleanRandomForest,
                    buildParamsJ48:null,
                    buildParamsRT:null,
                    buildParamsREP:null,
                    buildParamsFURIA:null,
                    buildParamsHTFuzzy:null,
                    buildParamsRF:null
                })
        }
    )
        .then(res => {
            if (res.status === 201) {
                return res.json().then(data => {
                    return { error: false, status: res.status, data: data };
                });
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: "Unauthorized, please restart session"
            };
        });

    return response;
}

export async function buildTree(name, classifier, token) {
  const response = await fetch(
    API_ROOT + "/classifier/tree/" + name + "/" + classifier,
    {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json"
      }
    }
  )
    .then(res => {
      if (res.status === 201) {
        return res.json().then(data => {
          return { error: false, status: res.status, data: data };
        });
      } else {
        return res.json().then(data => {
          return { error: true, status: res.status, data: data.message };
        });
      }
    })
    .catch(error => {
      return {
        error: true,
        status: 401,
        data: "Unauthorized, please restart session"
      };
    });

  return response;
}

export async function buildRules(name, classifier, token) {
  const response = await fetch(
    API_ROOT + "/classifier/fuzzy/" + name + "/" + classifier,
    {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json"
      }
    }
  )
    .then(res => {
      if (res.status === 201) {
        return res.json().then(data => {
          return { error: false, status: res.status, data: data };
        });
      } else {
        return res.json().then(data => {
          return { error: true, status: res.status, data: data.message };
        });
      }
    })
    .catch(error => {
      return {
        error: true,
        status: 401,
        data: "Unauthorized, please restart session"
      };
    });

  return response;
}

export async function updateAttributeConfig(
  name,
  attribute,
  config,
  lang,
  token
) {
  const response = await fetch(
    API_ROOT +
      "/classifier/config/" +
      name +
      "/numattribute/" +
      attribute +
      "?lang=" +
      lang,
    {
      method: "PUT",
      headers: {
        Authorization: token,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(config)
    }
  )
    .then(res => {
      if (res.status === 200) {
        return res.json().then(data => {
          return { error: false, status: res.status, data: data };
        });
      } else {
        return res.json().then(data => {
          return { error: true, status: res.status, data: data.message };
        });
      }
    })
    .catch(error => {
      return {
        error: true,
        status: 401,
        data: "Unauthorized, please restart session"
      };
    });

  return response;
}

export async function updateAttributeNormalizedConfig(
    name,
    attribute,
    config,
    lang,
    token
) {
    const response = await fetch(
        API_ROOT +
        "/classifier/config/" +
        name +
        "/numattributeNormalized/" +
        attribute +
        "?lang=" +
        lang,
        {
            method: "PUT",
            headers: {
                Authorization: token,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(config)
        }
    )
        .then(res => {
            if (res.status === 200) {
                return res.json().then(data => {
                    return { error: false, status: res.status, data: data };
                });
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: "Unauthorized, please restart session"
            };
        });

    return response;
}
export async function updateCategoricAttributeConfig(
  name,
  attribute,
  config,
  lang,
  token
) {
  const response = await fetch(
    API_ROOT +
      "/classifier/config/" +
      name +
      "/catattribute/" +
      attribute +
      "?lang=" +
      lang,
    {
      method: "PUT",
      headers: {
        Authorization: token,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(config)
    }
  )
    .then(res => {
      if (res.status === 200) {
        return res.json().then(data => {
          return { error: false, status: res.status, data: data };
        });
      } else {
        return res.json().then(data => {
          return { error: true, status: res.status, data: data.message };
        });
      }
    })
    .catch(error => {
      return {
        error: true,
        status: 401,
        data: "Unauthorized, please restart session"
      };
    });

  return response;
}

export async function updateConsequentConfig(
    name,
    consequent,
    config,
    lang,
    token
) {
    const response = await fetch(
        API_ROOT +
        "/classifier/config/" +
        name +
        "/consequent/" +
        consequent +
        "?lang=" +
        lang,
        {
            method: "PUT",
            headers: {
                Authorization: token,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(config)
        }
    )
        .then(res => {
            if (res.status === 200) {
                return res.json().then(data => {
                    return { error: false, status: res.status, data: data };
                });
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: "Unauthorized, please restart session"
            };
        });

    return response;
}
export async function addAttributeInterval(
  name,
  attribute,
  property,
  lang,
  token
) {
  const response = await fetch(
    API_ROOT +
      "/classifier/config/" +
      name +
      "/numattribute/" +
      attribute +
      "?lang=" +
      lang,
    {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(property)
    }
  )
    .then(res => {
      if (res.status === 201) {
        return res.json().then(data => {
          return { error: false, status: res.status, data: data };
        });
      } else {
        return res.json().then(data => {
          return { error: true, status: res.status, data: data.message };
        });
      }
    })
    .catch(error => {
      return {
        error: true,
        status: 401,
        data: "Unauthorized, please restart session"
      };
    });

  return response;
}

export async function addAttributeIntervalNormalized(
    name,
    attribute,
    property,
    lang,
    token
) {
    const response = await fetch(
        API_ROOT +
        "/classifier/config/" +
        name +
        "/numattributeNormalized/" +
        attribute +
        "?lang=" +
        lang,
        {
            method: "POST",
            headers: {
                Authorization: token,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(property)
        }
    )
        .then(res => {
            if (res.status === 201) {
                return res.json().then(data => {
                    return { error: false, status: res.status, data: data };
                });
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: "Unauthorized, please restart session"
            };
        });

    return response;
}


export async function deleteAttributeInterval(
  name,
  attribute,
  property,
  lang,
  token
) {
  const response = await fetch(
    API_ROOT +
      "/classifier/config/" +
      name +
      "/numattribute/" +
      attribute +
      "/" +
      property +
      "?lang=" +
      lang,
    {
      method: "DELETE",
      headers: {
        Authorization: token,
        "Content-Type": "application/json"
      }
    }
  )
    .then(res => {
      if (res.status === 200) {
        return res.json().then(data => {
          return { error: false, status: res.status, data: data };
        });
      } else {
        return res.json().then(data => {
          return { error: true, status: res.status, data: data.message };
        });
      }
    })
    .catch(error => {
      return {
        error: true,
        status: 401,
        data: "Unauthorized, please restart session"
      };
    });

  return response;
}

export async function deleteAttributeIntervalNormalized(
    name,
    attribute,
    property,
    lang,
    token
) {
    const response = await fetch(
        API_ROOT +
        "/classifier/config/" +
        name +
        "/numattributeNormalized/" +
        attribute +
        "/" +
        property +
        "?lang=" +
        lang,
        {
            method: "DELETE",
            headers: {
                Authorization: token,
                "Content-Type": "application/json"
            }
        }
    )
        .then(res => {
            if (res.status === 200) {
                return res.json().then(data => {
                    return { error: false, status: res.status, data: data };
                });
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: "Unauthorized, please restart session"
            };
        });

    return response;
}

export async function downloadConfig(name, lang, token) {
  const response = await fetch(
    API_ROOT + "/classifier/config/" + name + "/download?lang=" + lang,
    {
      method: "GET",
      headers: {
        Authorization: token
      }
    }
  )
    .then(res => {
      if (res.status === 200) {
        return res.blob().then(blob => {
          return blob;
        });
      } else {
        return res.json().then(data => {
          return { error: true, status: res.status, data: data.message };
        });
      }
    })
    .catch(error => {
      return {
        error: true,
        status: 401,
        data: "Unauthorized, please restart session"
      };
    });

  return response;
}

export async function uploadTest(name, file, token) {
  const data = new FormData();
  data.append("file", file);
  const response = await fetch(API_ROOT + "/dataset/" + name + "/test", {
    method: "POST",
    headers: {
      Authorization: token
    },
    body: data
  })
    .then(res => {
      if (res.status === 201) {
        return res.json().then(data => {
          return { error: false, status: res.status, data: data };
        });
      } else {
        return res.json().then(data => {
          return { error: true, status: res.status, data: data.message };
        });
      }
    })
    .catch(error => {
      return {
        error: true,
        status: 401,
        data: "Unauthorized, please restart session"
      };
    });

  return response;
}
export async function getLogText(name, algorithm, token) {
  const response = await fetch(
      API_ROOT + "/classifier/plainLog/" + name +"/"+algorithm,
      {
        method: "GET",
        headers: {
          Authorization: token
        }
      }
  )
      .then(res => {
        if (res.status === 200) {
          return res.text().then(data => {
            return { error: false, status: res.status, data: data };
          });
        } else {
          return res.json().then(data => {
            return { error: true, status: res.status, data: data.message };
          });
        }
      })
      .catch(error => {
        return {
          error: true,
          status: 401,
          data: error
        };
      });
  return response;
}

export async function getJsonTree(name, algorithm, token) {
    const response = await fetch(
        API_ROOT + "/classifier/jsonTree/" + name +"/"+algorithm,
        {
            method: "GET",
            headers: {
                Authorization: token
            }
        }
    )
        .then(res => {
            if (res.status === 200) {
                return res.text().then(data => {
                    return { error: false, status: res.status, data: data };
                });
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: error
            };
        });
    return response;
}

export async function getLogIEE(name, algorithm, token) {
    const response = await fetch(
        API_ROOT + "/classifier/logIEEE/" + name +"/"+algorithm,
        {
            method: "GET",
            headers: {
                Authorization: token
            }
        }
    )
        .then(res => {
            if (res.status === 200) {
                return res.text().then(data => {
                    return { error: false, status: res.status, data: data };
                });
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: error
            };
        });
    return response;
}

export async function getLogJFML(name, algorithm, token) {
    const response = await fetch(
        API_ROOT + "/classifier/logJFML/" + name +"/"+algorithm,
        {
            method: "GET",
            headers: {
                Authorization: token
            }
        }
    )
        .then(res => {
            if (res.status === 200) {
                return res.text().then(data => {
                    return { error: false, status: res.status, data: data };
                });
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: error
            };
        });
    return response;
}

export async function getLogJFMLFURIA(name, token) {
    const response = await fetch(
        API_ROOT + "/classifier/logJFMLFURIA/" + name ,
        {
            method: "GET",
            headers: {
                Authorization: token
            }
        }
    )
        .then(res => {
            if (res.status === 200) {
                return res.text().then(data => {
                    return { error: false, status: res.status, data: data };
                });
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: error
            };
        });
    return response;
}


export async function getJsonRules(name, algorithm, token) {
    const response = await fetch(
        API_ROOT + "/classifier/jsonRules/" + name +"/"+algorithm,
        {
            method: "GET",
            headers: {
                Authorization: token
            }
        }
    )
        .then(res => {
            if (res.status === 200) {
                return res.text().then(data => {
                    return { error: false, status: res.status, data: data };
                });
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: error
            };
        });
    return response;
}


export async function getLogFingrams(name, algorithm, token) {
    const response = await fetch(
        API_ROOT + "/fingrams/logFingrams/" + name +"/"+algorithm,
        {
            method: "GET",
            headers: {
                Authorization: token
            }
        }
    )
        .then(res => {

            if (res.status === 200) {
                return res.text().then(data => {
                    return { error: false, status: res.status, data: data };
                });
            } else {
                    return { error: true, status: res.status, data: "Error" };
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: error
            };
        });
    return response;
}

export async function getLogFingramsTest(name, algorithm, token) {
    const response = await fetch(
        API_ROOT + "/fingrams/test/logFingrams/" + name +"/"+algorithm,
        {
            method: "GET",
            headers: {
                Authorization: token
            }
        }
    )
        .then(res => {

            if (res.status === 200) {
                return res.text().then(data => {
                    return { error: false, status: res.status, data: data };
                });
            } else {
                return { error: true, status: res.status, data: "Error" };
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: error
            };
        });
    return response;
}

export async function downloadLog(name, algorithm, token) {
  const response = await fetch(
      API_ROOT + "/classifier/plainLog/" + name +"/"+algorithm,
      {
        method: "GET",
        headers: {
          Authorization: token
        }
      }
  )
      .then(res => {
        if (res.status === 200) {
          return res.blob().then(blob => {
            return blob;
          });
        } else {
          return res.json().then(data => {
            return { error: true, status: res.status, data: data.message };
          });
        }
      })
      .catch(error => {
        return {
          error: true,
          status: 401,
          data: "Unauthorized, please restart session"
        };
      });

  return response;
}

export async function downloadLogFingrams(name, algorithm, token) {
    const response = await fetch(
        API_ROOT + "/fingrams/logFingrams/" + name +"/"+algorithm,
        {
            method: "GET",
            headers: {
                Authorization: token
            }
        }
    )
        .then(res => {
            if (res.status === 200) {
                return res.blob().then(blob => {
                    return blob;
                });
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: "Unauthorized, please restart session"
            };
        });

    return response;
}

export async function downloadJsonTree(name, algorithm, token) {
    const response = await fetch(
        API_ROOT + "/classifier/jsonTree/" + name +"/"+algorithm,
        {
            method: "GET",
            headers: {
                Authorization: token
            }
        }
    )
        .then(res => {
            if (res.status === 200) {
                return res.blob().then(blob => {
                    return blob;
                });
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: "Unauthorized, please restart session"
            };
        });

    return response;
}


export async function downloadJsonRules(name, algorithm, token) {
    const response = await fetch(
        API_ROOT + "/classifier/jsonRules/" + name +"/"+algorithm,
        {
            method: "GET",
            headers: {
                Authorization: token
            }
        }
    )
        .then(res => {
            if (res.status === 200) {
                return res.blob().then(blob => {
                    return blob;
                });
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: "Unauthorized, please restart session"
            };
        });

    return response;
}

export async function downloadLogIEE(name, algorithm, token) {
    const response = await fetch(
        API_ROOT + "/classifier/logIEEE/" + name +"/"+algorithm,
        {
            method: "GET",
            headers: {
                Authorization: token
            }
        }
    )
        .then(res => {
            if (res.status === 200) {
                return res.blob().then(blob => {
                    return blob;
                });
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: "Unauthorized, please restart session"
            };
        });

    return response;
}
export async function downloadLogJFML(name, algorithm, token) {
    const response = await fetch(
        API_ROOT + "/classifier/logJFML/" + name +"/"+algorithm,
        {
            method: "GET",
            headers: {
                Authorization: token
            }
        }
    )
        .then(res => {
            if (res.status === 200) {
                return res.blob().then(blob => {
                    return blob;
                });
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: "Unauthorized, please restart session"
            };
        });

    return response;
}
export async function downloadLogJFMLFURIA(name, token) {
    const response = await fetch(
        API_ROOT + "/classifier/logJFMLFURIA/" + name ,
        {
            method: "GET",
            headers: {
                Authorization: token
            }
        }
    )
        .then(res => {
            if (res.status === 200) {
                return res.blob().then(blob => {
                    return blob;
                });
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: "Unauthorized, please restart session"
            };
        });

    return response;
}
export async function buildFingrams(name, algorithm, token,lang) {
  const response = await fetch(
      API_ROOT + "/fingrams/" + name +"/"+algorithm + "?lang=" + lang,
      {
        method: "POST",
        headers: {
          Authorization: token
        }
      }
  )
      .then(res => {
        if (res.status === 201) {
          return true
        } else {
          return res.json().then(data => {
            return { error: true, status: res.status, data: data.message };
          });
        }
      })
      .catch(error => {
        return {
          error: true,
          status: 401,
          data: "Unauthorized, please restart session"
        };
      });

  return response;
}

export async function buildSomeFingrams(name, booleanJ48,booleanRandomTree,booleanREPTree,booleanFURIA,
                                        booleanHoeffdingTreeFuzzy, booleanRandomForest,paramsJ48,paramsRT,
                                        paramsRep, paramsFURIA, paramsHtFuzzy, paramsRF, token) {
    const response = await fetch(
        API_ROOT + "/fingrams/some/" + name ,
        {
            method: "POST",
            headers: {
                Authorization: token,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(
                {
                    j48:booleanJ48,
                    randomTree:booleanRandomTree,
                    repTree:booleanREPTree,
                    furia: booleanFURIA,
                    hoeffdingTreeFuzzy:booleanHoeffdingTreeFuzzy,
                    randomForest:booleanRandomForest,
                    buildParamsJ48:paramsJ48,
                    buildParamsRT:paramsRT,
                    buildParamsREP:paramsRep,
                    buildParamsFURIA:paramsFURIA,
                    buildParamsHTFuzzy:paramsHtFuzzy,
                    buildParamsRF:paramsRF
                })
        }
    )
        .then(res => {
            if (res.status === 201) {
                return true
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: "Unauthorized, please restart session"
            };
        });

    return response;
}
export async function buildSomeIEE(name, booleanJ48,booleanRandomTree,booleanREPTree,booleanFURIA,
                                        booleanHoeffdingTreeFuzzy, booleanRandomForest,paramsJ48,paramsRT,
                                        paramsRep, paramsFURIA, paramsHtFuzzy, paramsRF, token) {
    const response = await fetch(
        API_ROOT + "/builder/some/iee/" + name ,
        {
            method: "POST",
            headers: {
                Authorization: token,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(
                {
                    j48:booleanJ48,
                    randomTree:booleanRandomTree,
                    repTree:booleanREPTree,
                    furia: booleanFURIA,
                    hoeffdingTreeFuzzy:booleanHoeffdingTreeFuzzy,
                    randomForest:booleanRandomForest,
                    buildParamsJ48:paramsJ48,
                    buildParamsRT:paramsRT,
                    buildParamsREP:paramsRep,
                    buildParamsFURIA:paramsFURIA,
                    buildParamsHTFuzzy:paramsHtFuzzy,
                    buildParamsRF:paramsRF
                })
        }
    )
        .then(res => {
            if (res.status === 201) {
                return true
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: "Unauthorized, please restart session"
            };
        });

    return response;
}
export async function buildIEEE(name,algorithm, token) {
    const response = await fetch(
        API_ROOT + "/builder/ieee/" + name +"/"+algorithm,
        {
            method: "POST",
            headers: {
                Authorization: token,
                "Content-Type": "application/json"
            }
        }
    )
        .then(res => {
            if (res.status === 201) {
                return true
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: "Unauthorized, please restart session"
            };
        });

    return response;
}

export async function buildFingramsTest(name, algorithm, token,lang) {
    const response = await fetch(
        API_ROOT + "/fingrams/test/" + name +"/"+algorithm + "?lang=" + lang,
        {
            method: "POST",
            headers: {
                Authorization: token
            }
        }
    )
        .then(res => {
            if (res.status === 201) {
                return true
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: "Unauthorized, please restart session"
            };
        });

    return response;
}

export async function getSvgFingramComplete(name, algorithm, token) {
  const response = await fetch(
      API_ROOT + "/fingrams/" + name +"/"+algorithm,
      {
        method: "GET",
        headers: {
          Authorization: token
        }
      }
  )
      .then(res => {
        if (res.status === 200) {
          return res.text().then(data => {
            console.log(data);
            return { error: false, status: res.status, data: data };
          });
        } else {
          return  { error: true, status:500 , data: "Error" };
        }
      })
      .catch(error => {
        return {
          error: true,
          status: 401,
          data: error
        };
      });
  return response;
}
export async function getSvgFingramLegend(name, algorithm, token) {
  const response = await fetch(
      API_ROOT + "/fingrams/legend/" + name +"/"+algorithm,
      {
        method: "GET",
        headers: {
          Authorization: token
        }
      }
  )
      .then(res => {
        if (res.status === 200) {
          return res.text().then(data => {
            console.log(data);
            return { error: false, status: res.status, data: data };
          });
        } else {
          return res.json().then(data => {
            return { error: true, status: res.status, data: data.message };
          });
        }
      })
      .catch(error => {
        return {
          error: true,
          status: 401,
          data: error
        };
      });
  return response;
}
export async function getSvgFingramPathfinder(name, algorithm, token) {
  const response = await fetch(
      API_ROOT + "/fingrams/pathfinder/" + name +"/"+algorithm,
      {
        method: "GET",
        headers: {
          Authorization: token
        }
      }
  )
      .then(res => {
        if (res.status === 200) {
          return res.text().then(data => {
            console.log(data);
            return { error: false, status: res.status, data: data };
          });
        } else {
          return res.json().then(data => {
            return { error: true, status: res.status, data: data.message };
          });
        }
      })
      .catch(error => {
        return {
          error: true,
          status: 401,
          data: error,
        };
      });
  return response;
}
export async function getSvgFingramInconsistenciesPathfinder(name, algorithm, token) {
  const response = await fetch(
      API_ROOT + "/fingrams/inconsistenciesPathfinder/" + name +"/"+algorithm,
      {
        method: "GET",
        headers: {
          Authorization: token
        }
      }
  )
      .then(res => {
        if (res.status === 200) {
          return res.text().then(data => {
            console.log(data);
            return { error: false, status: res.status, data: data };
          });
        } else {
          return res.json().then(data => {
            return { error: true, status: res.status, data: data.message };
          });
        }
      })
      .catch(error => {
        return {
          error: true,
          status: 401,
          data: error
        };
      });
  return response;
}

export async function getSvgFingramTestComplete(name, algorithm, token) {
    const response = await fetch(
        API_ROOT + "/fingrams/test/" + name +"/"+algorithm,
        {
            method: "GET",
            headers: {
                Authorization: token
            }
        }
    )
        .then(res => {
            if (res.status === 200) {
                return res.text().then(data => {
                    console.log(data);
                    return { error: false, status: res.status, data: data };
                });
            } else {
                return  { error: true, status:500 , data: "Error" };
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: error
            };
        });
    return response;
}
export async function getSvgFingramTestLegend(name, algorithm, token) {
    const response = await fetch(
        API_ROOT + "/fingrams/test/legend/" + name +"/"+algorithm,
        {
            method: "GET",
            headers: {
                Authorization: token
            }
        }
    )
        .then(res => {
            if (res.status === 200) {
                return res.text().then(data => {
                    console.log(data);
                    return { error: false, status: res.status, data: data };
                });
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: error
            };
        });
    return response;
}
export async function getSvgFingramTestPathfinder(name, algorithm, token) {
    console.log('PathFidner');
    const response = await fetch(
        API_ROOT + "/fingrams/test/pathfinder/" + name +"/"+algorithm,
        {
            method: "GET",
            headers: {
                Authorization: token
            }
        }
    )
        .then(res => {
            if (res.status === 200) {
                return res.text().then(data => {
                    console.log(data);
                    return { error: false, status: res.status, data: data };
                });
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: error,
            };
        });
    return response;
}
export async function getSvgFingramTestInconsistenciesPathfinder(name, algorithm, token) {
    const response = await fetch(
        API_ROOT + "/fingrams/test/inconsistenciesPathfinder/" + name +"/"+algorithm,
        {
            method: "GET",
            headers: {
                Authorization: token
            }
        }
    )
        .then(res => {
            if (res.status === 200) {
                return res.text().then(data => {
                    console.log(data);
                    return { error: false, status: res.status, data: data };
                });
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: error
            };
        });
    return response;
}
export async function buildSvgFingramInstance(name, algorithm, token,instance) {
  console.log(instance);
  instance++;
  const response = await fetch(
      API_ROOT + "/fingrams/buildSvgInstance/" + name +"/"+algorithm+"?instance=" + instance,
      {
        method: "POST",
        headers: {
          Authorization: token,
          "Content-Type": "application/json"
        }
      }
  )
      .then(res => {
        if (res.status === 200) {
          return res.text().then(data => {
            console.log(data);
            return { error: false, status: res.status, data: data };
          });
        } else {
          return res.json().then(data => {
            return { error: true, status: res.status, data: data.message };
          });
        }
      })
      .catch(error => {
        return {
          error: true,
          status: 401,
          data: error
        };
      });
  return response;
}
export async function buildSvgFingramInstanceTest(name, algorithm, token,instance) {
    console.log(instance);
    instance++;
    const response = await fetch(
        API_ROOT + "/fingrams/test/buildSvgInstance/" + name +"/"+algorithm+"?instance=" + instance,
        {
            method: "POST",
            headers: {
                Authorization: token,
                "Content-Type": "application/json"
            }
        }
    )
        .then(res => {
            if (res.status === 200) {
                return res.text().then(data => {
                    console.log(data);
                    return { error: false, status: res.status, data: data };
                });
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: error
            };
        });
    return response;
}
export async function getSvgFingramInstance(name, algorithm, token) {
  const response = await fetch(
      API_ROOT + "/fingrams/instance/" + name +"/"+algorithm,
      {
        method: "POST",
        headers: {
          Authorization: token
        }
      }
  )
      .then(res => {
        if (res.status === 200) {
          return res.text().then(data => {
            console.log(data);
            return { error: false, status: res.status, data: data };
          });
        } else {
          return res.json().then(data => {
            return { error: true, status: res.status, data: data.message };
          });
        }
      })
      .catch(error => {
        return {
          error: true,
          status: 401,
          data: error
        };
      });
  return response;
}
export async function getListOfAlgorithms(name, token) {
    const response = await fetch(
        API_ROOT + "/classifier/listOfAlgorithms/" + name ,
        {
            method: "GET",
            headers: {
                Authorization: token
            }
        }
    )
        .then(res => {
            console.log(res)
            if (res.status === 200) {
                return res.json().then(data => {
                    console.log(data);
                    return { error: false, status: res.status, data: data };
                });
            } else {
                return res.json().then(data => {
                    return { error: true, status: res.status, data: data.message };
                });
            }
        })
        .catch(error => {
            return {
                error: true,
                status: 401,
                data: error
            };
        });
    return response;
}